import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FrontUserService } from '../../../core/services/frontUsers.service';
import { CommunicationFormDialogComponent } from './setting-form/setting-form.component';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {DatePipe, Location} from '@angular/common';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { CommunicationService } from '../../../core/services/communication.service';
import { fromEvent as observableFromEvent} from 'rxjs';
import { distinctUntilChanged, debounceTime, map } from 'rxjs/operators';
import { fuseAnimations } from '../../../core/animations';
import { CommunicationCopyFormDialogComponent } from './setting-form-copy/setting-form.component';
import {NgxSpinnerService} from 'ngx-spinner';
import {DomSanitizer} from '@angular/platform-browser';
import jsPDF from 'jspdf';
import * as PDFObject from 'pdfobject';
import {FuseConfigService} from '../../../core/services/config.service';
import {FuseDeleteDialogComponent} from '../../../core/components/delete-dialog/delete-dialog.component';
import {ToastrService } from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import { DocumentsService } from '../../../core/services/documents.service';

@Component({
    selector: 'communications-page',
    templateUrl: './communications.component.html',
    styleUrls: ['./communications.component.scss'],
    animations: fuseAnimations,
    standalone: false
})
export class CommunicationsComponent implements OnInit {
  communications = [];
  displayedColumns = ['type', 'names', 'description', 'sent'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('filter', {static: true}) filter: ElementRef;
  @ViewChild(MatSort) sort: MatSort;
  data;
  ids = '';
  guestIds = '';
  dialogRef: any;
  page;
  back = true;
  selectedType = 'mail';
  _pageIndex = 0;
  _perPage = 25;
  _sort = 'createdAt';
  _direction = 'desc';
  _search = '';
  pagination: any = {};
  mailBody: any = '';
  mailTitle: any = '';
  mailUsers: any = '';
  mailDocs: any = [];
  chosenEmail;
  usersData = [];
  userInfo;
  text = '';
  typeOfLetter = 'left';
  left = 27;
  top = 48;
  description = '';
  welcome;
  end;
  date;
  organization;
  usersForSend;
  organizationLogo = false;
  inviteUrl = false;
  users = [];
  websiteLink = 'https://www.pfefferstern.ch/';
  smsText = '';
  showFullName = false;
  whatsapp = false;
  constructor(private bottomSheet: MatBottomSheet, public translate: TranslateService,
              private location: Location, public toastr: ToastrService ,
              private http: HttpClient, public router: Router, private route: ActivatedRoute,
              private frontUser: FrontUserService, public dialog: MatDialog, private organizationTypesService: CommunicationService,
              private spinner: NgxSpinnerService, private sanitizer: DomSanitizer, private fuseConfig: FuseConfigService,
              private documentsService: DocumentsService) {
    this.fuseConfig.projectSettings.subscribe((res: any) => {
      if (res) {
        this.websiteLink = res.websiteLink;
      }
    });
    this.fuseConfig.whatsapp.subscribe(res => {
      if (res && res !== 'null') {
        this.whatsapp = true;
      }
    });
    this.fuseConfig.role.subscribe(res => {
      if (res && res === 'superAdmin') {
        this.whatsapp = true;
      }
    });
    this.ids = this.route.snapshot.queryParamMap.get('ids');
    this.guestIds = this.route.snapshot.queryParamMap.get('guestIds');
    const type = this.route.snapshot.queryParamMap.get('type');
    const userType = this.route.snapshot.queryParamMap.get('userType');
    const subtype = this.route.snapshot.queryParamMap.get('subtype');
    if (this.ids) {
      if (subtype === 'participant') {
        this.dialogRef = this.dialog.open(CommunicationFormDialogComponent, {
          panelClass: 'contact-form-dialog',
          width: '70vw',
          data: {
            action: type,
            data: this.ids.split(','),
            subtype: 'participant'
          }
        });
        this.dialogRef.afterClosed()
          .subscribe((response: any) => {
            this.getCommunicationsData();
          });
      } else {
        if (userType === 'admin') {
          this.frontUser.getAdminByIds(this.ids).subscribe((res) => {
            this.dialogRef = this.dialog.open(CommunicationFormDialogComponent, {
              panelClass: 'contact-form-dialog',
              width: '70vw',
              data: {
                action: type,
                data: res,
                userType: 'admin'
              }
            });
            this.dialogRef.afterClosed()
              .subscribe((response: any) => {
                this.getCommunicationsData();
              });
          });
        } else {
          this.frontUser.getUsersByIds(this.ids).subscribe((res: any) => {
            if (this.guestIds) {
              this.frontUser.guestUserByIds(this.guestIds).subscribe((guests: any) => {
                let allUsers = [];
                allUsers = allUsers.concat(res);
                allUsers = allUsers.concat(guests);
                this.openModal(type, allUsers);
              });
            } else {
              this.openModal(type, res);
            }
          });
        }
      }
    } else {
      if (this.guestIds) {
        this.frontUser.guestUserByIds(this.guestIds).subscribe((guests: any) => {
          const allUsers = guests;
          this.openModal(type, allUsers);
        });
      }
    }
  }

  openModal(type, data) {
    this.dialogRef = this.dialog.open(CommunicationFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '70vw',
      data: {
        action: type,
        data: data
      }
    });
    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        this.getCommunicationsData();
      });
  }

  ngOnInit() {
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(800),
      distinctUntilChanged())
      .subscribe(() => {
        if (this.filter.nativeElement.value && this.filter.nativeElement.value.replace(/ /g, '')
          && this.filter.nativeElement.value !== null && this.filter.nativeElement.value !== 'null') {
          this._search = this.filter.nativeElement.value;
          this._pageIndex = 0;
          this.getCommunicationsData();
        } else if ((!this.filter.nativeElement.value || this.filter.nativeElement.value === '') && this._search) {
          this._search = '';
          this._pageIndex = 0;
          this.getCommunicationsData();
        }
      });
    this.getCommunicationsData();
  }

  changeType(e) {
    this.selectedType = e;
    this._pageIndex = 0;
    this.getCommunicationsData();
  }

  changePageEmitter(e) {
    this._pageIndex = e.pageIndex;
    this._perPage = e.pageSize;
    this.getCommunicationsData();
  }

  chooseMail(data, id) {
    this.chosenEmail = data;
    let mailBody1 = data.data.body1;
    let mailBody2 = data.data.body2;
    let mailBody3 = data.data.body3;
    let body = data.data.body;
    let subject = data.data.subject;
    this.mailTitle = data.data.subject;
    let typeOfMessage = data.data.typeOfMessage;
    if (data.data.mails) {
      this.mailUsers = data.data.mails.split(',').filter(x => x).join(', ');
    }
    if (data.documents) {
      this.mailDocs = data.documents;
    }
    let greeting = typeOfMessage !== 'family' ? 'Hallo fistName lastName,  ' : 'Familie lastName und fistName';
    this.mailBody = this.sanitizer.bypassSecurityTrustHtml(mailBody1 + (subject ? subject : '') + mailBody2 + greeting + (body ? body : '') + mailBody3);
    let allChoosenEmails = document.getElementsByClassName('email-choosen');
    if (allChoosenEmails && allChoosenEmails.length) {
      for (let i = 0; i < allChoosenEmails.length; i++) {
        allChoosenEmails[i].classList.remove('email-choosen');
      }
    }
    let _email = document.getElementById(id);
    if (_email) {
      _email.classList.add('email-choosen');
    }
  }

  getFile(name) {
    return this.documentsService.getFileStream(name);
  }

  getCommunicationsData() {
    this.communications = [];
    this.spinner.show();
    this.organizationTypesService.getCommunications(this.selectedType, this._pageIndex + 1, this._perPage,
      this._sort, this._direction, this._search).subscribe((res: any) => {
      res.communication.map((item) => {
        if (item.data) {
          item.data = JSON.parse(item.data);
        }
        if (item.type === 'sms' || item.type === 'whatsapp') {
          item.dataForShow = item.data['numbers'].split(',');
        }
        if (item.type === 'mail') {
          item.dataForShow = item.data['mails'].split(',');
        }
        if (item.type === 'serial') {
          item.dataForShow = item.data['userInfo'];
        }
        if (this.selectedType === 'mail' && item.users && item.users.length > 6) {
          item.usersShort = item.users.filter(el => el.email);
          item.usersShort.splice(6);
        } else {
          if (this.selectedType === 'mail' && item && item.users && item.users.length) {
            item.usersShort = item.users.filter(el => el.email);
          }
        }
        if (this.selectedType === 'serial' && item.data.userInfo && item.data.userInfo.length > 6) {
          item.usersShort = item.data.userInfo;
          item.usersShort.splice(6);
        } else {
          if (this.selectedType === 'serial') {
            item.usersShort = item.data.userInfo;
          }
        }
      });
      this.communications = res.communication;
      this.pagination = res.pagination;
      if (this.selectedType === 'mail') {
        setTimeout(() => {
          this.mailBody = '';
          this.mailUsers = '';
          this.mailDocs = [];
          this.mailTitle = '';
          this.chosenEmail = '';
          if (this.communications && this.communications.length) {
            this.chooseMail(this.communications[0], this.communications[0].id);
          }
        }, 1000);
      } else if (this.selectedType === 'serial') {
        setTimeout(() => {
          this.mailBody = '';
          this.mailUsers = '';
          this.mailDocs = [];
          this.mailTitle = '';
          this.chosenEmail = '';
          if (this.communications && this.communications.length) {
            this.createPdf(this.communications[0], this.communications[0].id);
          }
        }, 1000);
      } else if (this.selectedType === 'sms' || this.selectedType === 'whatsapp') {
        setTimeout(() => {
          this.mailBody = '';
          this.mailUsers = '';
          this.mailDocs = [];
          this.mailTitle = '';
          this.chosenEmail = '';
          if (this.communications && this.communications.length) {
            this.creatSMS(this.communications[0], this.communications[0].id);
          }
        }, 1000);
      } else {
        this.mailBody = '';
        this.mailUsers = '';
        this.mailDocs = [];
        this.mailTitle = '';
        this.chosenEmail = '';
      }
      this.spinner.hide();
    }, error => {
      this.spinner.hide();
    });
  }

  openBottomSheet(event, data): void {
    event.stopPropagation();
    this.bottomSheet.open(BottomSheetOverviewExampleSheet, {data: data});
  }

  goBack() {
    this.location.back();
  }

  editType(data) {
    this.dialogRef = this.dialog.open(CommunicationCopyFormDialogComponent, {
      panelClass: 'contact-form-dialog',
      width: '70vw',
      data: {
        action: data.type,
        data: data.data,
        spec: 'communication',
        description: data.description,
      }
    });

    this.dialogRef.afterClosed()
      .subscribe((response: any) => {
        if (response) {
          this.getCommunicationsData();
        }
      });
  }

  creatSMS(data, smsId){
    this.chosenEmail = data;
    let numbers = data.data.numbers.split(',');
    this.mailUsers = [];
    for (const number of numbers) {
      let user = data.users.filter(el => el.phone === number || el.mobile === number);
      if (user.length === 1) {
        this.mailUsers.push(user[0].firstName + ' ' + user[0].lastName);
      } else if (!user.length) {
        this.mailUsers.push(number);
      } else if (user.length > 1) {
        let findActivated = user.filter(el => el.activated);
        if (findActivated.length > 1) {
          this.mailUsers.push(findActivated[0].firstName + ' ' + findActivated[0].lastName);
        } else {
          this.mailUsers.push(user[0].firstName + ' ' + user[0].lastName);
        }
      }
    }
    this.mailUsers = this.mailUsers.join(', ');
    this.mailTitle = data.description;
    this.smsText = data.data.text;
    let allChoosenSMS = document.getElementsByClassName('email-choosen');
    if (allChoosenSMS && allChoosenSMS.length) {
      for (let i = 0; i < allChoosenSMS.length; i++) {
        allChoosenSMS[i].classList.remove('email-choosen');
      }
    }
    let _sms = document.getElementById(smsId);
    if (_sms) {
      _sms.classList.add('email-choosen');
    }
  }

  createPdf(data, serialId) {
    this.chosenEmail = data;
    this.mailUsers = '';
    this.mailTitle = data.description;
    let fontSize = 10;
    let textBody = '';
    const doc = new jsPDF();
    let imageSrc = '';
    let prorportionData = 2;
    this.text = data.data.text;
    this.welcome = data.data.welcome;
    this.end = data.data.end;
    this.date = data.data.date;
    this.organizationLogo = data.data.organizationLogo;
    this.showFullName = data.data.showFullName;
    this.inviteUrl = data.data.showUrl;
    if (data.data.users) {
      this.usersForSend = data.data.users.split(',');
      this.users = data.data.users.split(',');
    }
    this.userInfo = data.data.userInfo;
    for (let i = 0; i < this.userInfo.length; i++) {
      this.usersData.push({
        value: this.userInfo[ i ].id ,
        label: this.userInfo[ i ].firstName + ' ' + this.userInfo[ i ].lastName
      });
    }
    imageSrc = `data:image/jpeg;base64,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`;
    prorportionData = 2;
    if (this.end) {
      textBody = this.text + '\n\n' + this.end;
    } else {
      textBody = this.text;
    }
    if (this.usersForSend) {
      for (let i = 0; i < this.usersForSend.length; i++) {
        if (this.organizationLogo && this.organization && this.organization.logo) {
          doc.addImage(imageSrc, 'JPEG', 15, 5, 40 * prorportionData, 40);
        }
        let ofsetTop = this.top + fontSize / 4;
        doc.setFontSize(fontSize);
        let user = this.userInfo.filter(obj => {
          return +obj.id === +this.usersForSend[i];
        });
        if (user && user.length) {
          if (user[0].email) {
            this.mailUsers = this.mailUsers + user[0].email + ', ';
          }
          doc.text(user[0].lastName + ' ' + user[0].firstName, this.left ? this.left : 0, ofsetTop);
          ofsetTop = ofsetTop + fontSize / 2;
          doc.text(user[0].street + ' ' + user[0].number, this.left ? this.left : 0, ofsetTop);
          ofsetTop = ofsetTop + fontSize / 2;
          doc.text(user[0].postcode + ' ' + user[0].cityLocation, this.left ? this.left : 0, ofsetTop);

          if (this.date) {
            const pipe = new DatePipe('de-CH');
            const dateFormated = pipe.transform(this.date, 'dd.LLLL yyyy');
            ofsetTop = ofsetTop + fontSize * 2;
            doc.text(dateFormated, 25, ofsetTop);
          }

          if (this.welcome) {
            ofsetTop = ofsetTop + 20;
            if (this.showFullName) {
              doc.text(this.welcome + ' ' + user[ 0 ].firstName + ' ' + user[ 0 ].lastName, 25 , ofsetTop );
            } else {
              doc.text(this.welcome + ' ' + user[ 0 ].firstName, 25 , ofsetTop);
            }
          } else {
            ofsetTop = ofsetTop + 20;
          }
          if (this.inviteUrl) {
            if (user[ 0 ].activeCode) {
              let _text = this.translate.instant('active_code_information');
              textBody = textBody + '\n\n' + _text;
            } else {
              let _text = this.translate.instant('no_active_code_information');
              textBody = textBody + '\n\n' + _text;
            }
          }
          textBody = textBody ? textBody : '';
          ofsetTop = ofsetTop + 5;
          let textLines = doc
            .setFontSize(10)
            .setFont('normal')
            .splitTextToSize(textBody , 150);
          doc.text(textLines , 25 , ofsetTop);
          ofsetTop = ofsetTop + 5 * textLines.length;

          if (this.inviteUrl && user[ 0 ].activeCode) {
            textBody = user[ 0 ].activeCode;
            ofsetTop = ofsetTop + 5;

            textLines = doc
              .setFontSize(14)
              .setFont('bold')
              .splitTextToSize(textBody , 150);
            doc.text(textLines , 25 , ofsetTop);
          }

          if (this.end) {
            textBody = '\n\n' + this.end;
            textLines = doc
              .setFontSize(10)
              .setFont('normal')
              .splitTextToSize(textBody , 150);
            ofsetTop = ofsetTop + 5;
            doc.text(textLines , 25, ofsetTop);
          }
        }
        textBody = textBody ? textBody : '';
        let textLines = doc
          .setFontSize(10)
          .splitTextToSize(textBody, 150);

        ofsetTop = ofsetTop + 5;
        doc.text(textLines, 25, ofsetTop);

        if (i !== this.usersForSend.length - 1) {
          doc.addPage('a4');
        }
      }
    }
    this.mailUsers = this.mailUsers.substring(0, this.mailUsers.length - 2);
    PDFObject.embed(doc.output('datauristring'), '#example2');
    let allChoosenSerials = document.getElementsByClassName('email-choosen');
    if (allChoosenSerials && allChoosenSerials.length) {
      for (let i = 0; i < allChoosenSerials.length; i++) {
        allChoosenSerials[i].classList.remove('email-choosen');
      }
    }
    let _serial = document.getElementById(serialId);
    if (_serial) {
      _serial.classList.add('email-choosen');
    }
  }

  deleteMessage(email) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.organizationTypesService.deleteMsg(email.id).subscribe((res) => {
          this.toastr.success('Email deleted', 'Success!');
          this.getCommunicationsData();
        });
      }
    });
  }
}


@Component({
    selector: 'bottom-sheet-overview-example-sheet',
    templateUrl: 'bottom-sheet-overview-example-sheet.html',
    standalone: false
})
export class BottomSheetOverviewExampleSheet {
  constructor(private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewExampleSheet>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    console.log(data);
  }

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }
}

